const isSmallScreen = () => window.innerWidth <= 820; // iPad

const responsiveHelper = { isSmallScreen };

export default responsiveHelper;
